import axios from 'axios';

// Function to determine the API base URL based on the hostname
const getApiBaseUrl = () => {
  const { hostname, port } = window.location;

  // Main production environment
  if (hostname.endsWith('portal.bvdkphudien.com')) {
    return 'https://portal.bvdkphudien.com:5005/api';
  }
  
  // Development environment
  if (hostname === 'localhost' && port === '3000') {
    return process.env.REACT_APP_API_URL || 'http://localhost:5084/api';
  }
  
  // Other environments (IPs, etc.)
  switch (`${hostname}${port ? ':' + port : ''}`) {
    case '192.168.1.246:5003':
      return 'http://192.168.1.246:5005/api';
    case '113.160.172.217:5003':
      return 'http://113.160.172.217:5005/api';
    case '117.4.137.132:5003':
      return 'http://117.4.137.132:5005/api';
    // The default case should be the main production URL as a fallback
    default:
      return 'https://portal.bvdkphudien.com:5005/api';
  }
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
});

// Request Interceptor: Automatically attach the token to every request, except for /lich-su-cls
api.interceptors.request.use(
  config => {
    // Không gửi token cho API lich-su-cls (vì đây là API public cho bệnh nhân)
    if (!config.url?.includes('/lich-su-cls')) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle 401/403 errors globally, except for /lich-su-cls
api.interceptors.response.use(
  response => response, // Simply return the successful response
  error => {
    // Danh sách các PUBLIC PATH (route không cần login) - không redirect dù lỗi 401
    const publicPaths = ['/lich-su-cls/', '/dang-ky-kham-tu-xa', '/dang-ky-thanh-cong'];
    const currentPath = window.location.pathname;
    const isOnPublicPage = publicPaths.some(p => currentPath.startsWith(p));

    // Kiểm tra: (lỗi 401/403) VÀ (không phải API lich-su-cls) VÀ (user KHÔNG đang ở trang public)
    // => MỚI redirect về login
    if (error.response && [401, 403].includes(error.response.status) 
        && !error.config?.url?.includes('/lich-su-cls')
        && !isOnPublicPage) {
      console.error('Authentication error, redirecting to login.');
      // Remove user data from storage
      localStorage.removeItem('token');
      localStorage.removeItem('permissions');
      
      // Redirect to the login page. Using window.location.href is 
      // appropriate here as this is outside of React component lifecycle.
      window.location.href = '/login';
    }
    
    // For all other errors, just pass them on
    return Promise.reject(error);
  }
);

export default api;
